module.exports = __webpack_public_path__ + "img/Reg.19f45ffa.jpg";